import { t } from "@lingui/macro";
import i18n from "./i18n";

export default {
    parking_lot: {
        cost: 3,
        use_mode: "SINGLE",
        name: i18n._(t`Parking Lot`),
        description: i18n._(t`Take control over the parking lot of the town, earning 1 [Star]`)
    },
    car_dealership: {
        cost: 4,
        use_mode: "SINGLE",
        name: i18n._(t`Car Dealership`),
        description: i18n._(t`Take control over the town's car dealership, earning 2 [Star]`)
    },
    enterprise_building: {
        cost: 5,
        use_mode: "SINGLE",
        name: i18n._(t`Enterprise Building`),
        description: i18n._(t`Become the owner of the enterprise building in town, earning 3 [Star]`)
    },
    hospital: {
        cost: 6,
        use_mode: "SINGLE",
        name: i18n._(t`Hospital`),
        description: i18n._(t`Make the hospital yours, earning 4 [Star]`)
    },
    parachute_invasion: {
        cost: 5,
        use_mode: "SINGLE",
        name: i18n._(t`Parachute Invasion`),
        description: i18n._(t`They should've looked up! Join the parachute army and kick all players currently in town, entering it yourself. Earn 2 [Star] in addition`)
    },
    medical_treatment: {
        cost: 2,
        use_mode: "SINGLE",
        name: i18n._(t`Medical Treatment`),
        description: i18n._(t`You just found the right treatment, but it isn't free. Heal (even if in town) for 1 [Heart] at the cost of 1 [Energy]`)
    },
    ushape_magnet: {
        cost: 6,
        use_mode: "SINGLE",
        name: i18n._(t`U-Shape Magnet`),
        description: i18n._(t`Use this powerful magnet to make all the other monsters lose 1 [Energy] for each 2 [Energy] they have. In addition, earn 2 [Star]`)
    },
    whirlwind: {
        cost: 6,
        use_mode: "SINGLE",
        name: i18n._(t`Whirlwind`),
        description: i18n._(t`Go on a rampage and deal 3 [Damage] to all the other monsters. In addition, earn 2 [Star]`)
    },
    getaway: {
        cost: 6,
        use_mode: "SINGLE",
        name: i18n._(t`Getaway`),
        description: i18n._(t`Everyone loves a getaway every once in a while. Take some rest, heal (even if in town) for 3 [Heart] and earn 2 [Star].`)
    },
    fame_thirst: {
        cost: 4,
        use_mode: "SINGLE",
        name: i18n._(t`Fame Thirst`),
        description: i18n._(t`Fame comes at a high price. Earn 4 [Star] but lose 3 [Heart]`)
    },
    stardom_thirst: {
        cost: 5,
        use_mode: "SINGLE",
        name: i18n._(t`Stardom Thirst`),
        description: i18n._(t`Seeking stardom can become dangerous as there is always a tradeoff. Earn 5 [Star] but lose 4 [Heart]`)
    },
    gust: {
        cost: 3,
        use_mode: "SINGLE",
        name: i18n._(t`Gust`),
        description: i18n._(t`Invoke a violent gust that deals 2 [Damage] to all the other monsters`)
    },
    earthquake: {
        cost: 4,
        use_mode: "SINGLE",
        name: i18n._(t`Earthquake`),
        description: i18n._(t`Provoke an earthquake and cause a massive destruction in the town. Every monster (including you) loses 3 [Heart]`)
    },
    black_hole: {
        cost: 7,
        use_mode: "SINGLE",
        name: i18n._(t`Black Hole`),
        description: i18n._(t`Open a temporary black hole near the town, while you avoid it. All the other monsters lose 5 [Star]`)
    },
    bandage: {
        cost: 3,
        use_mode: "SINGLE",
        name: i18n._(t`Bandage`),
        description: i18n._(t`When you're bleeding a bandage comes in handy. Heal (even if in town) for 2 [Heart]`)
    },
    bargain: {
        cost: 8,
        use_mode: "SINGLE",
        name: i18n._(t`Bargain`),
        description: i18n._(t`Nothing else to say. This is a bargain! Earn 9 [Energy]`)
    },
    gaming_addiction: {
        cost: 7,
        use_mode: "SINGLE",
        name: i18n._(t`Gaming Addiction`),
        description: i18n._(t`Gaming can be addicting. Use this card to gain 1 extra (complete) turn`)
    },
    empowered_punch: {
        cost: 5,
        use_mode: "KEEP",
        name: i18n._(t`Empowered Punch`),
        description: i18n._(t`Empower your attacks while holding this card. Every attack deals +1 [Damage]`)
    },
    explosive_coat: {
        cost: 6,
        use_mode: "KEEP",
        name: i18n._(t`Explosive Spines Coat`),
        description: i18n._(t`A coat inspired on the pufferfish and powered by science! Its spines give you +1 [Damage], even if you don't attack`)
    },
    power_ostentation: {
        cost: 5,
        use_mode: "KEEP",
        name: i18n._(t`Power Ostentation`),
        description: i18n._(t`Show them who's got the power. Deal +1 [Damage] while in Town. In addition, deal 1 [Damage] to your successor when leaving the Town`)
    },
    ground_breaking_punch: {
        cost: 7,
        use_mode: "KEEP",
        name: i18n._(t`Ground-breaking Punch`),
        description: i18n._(t`Hitting only the enemies in town? That's not how you win! If you are outside the town, your attacks deal damage to all the other monsters`)
    },
    two_two_two: {
        cost: 4,
        use_mode: "KEEP",
        name: i18n._(t`Two-Two-Two`),
        description: i18n._(t`The two maniac. The deal is simple: roll [Roll-2][Roll-2][Roll-2] to also deal 2 [Damage]`)
    },
    big_heart: {
        cost: 4,
        use_mode: "KEEP",
        name: i18n._(t`Big Heart`),
        description: i18n._(t`Kudos for having such a big heart! Permanently increase your maximum health points by 2, and heal (even if in town) for 2 [Heart] upon buying this card`)
    },
    positive_charge: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`Positive Charge`),
        description: i18n._(t`This is feeling energetic! If you roll any [Roll-Energy], gain an additional +1 [Energy]`)
    },
    bank_loan: {
        cost: 2,
        use_mode: "KEEP",
        name: i18n._(t`Bank Loan`),
        description: i18n._(t`The energy banks are here to help you getting through. Earn 1 [Energy] if you don't have any [Energy] at the end of your turn`)
    },
    stellar_punch: {
        cost: 5,
        use_mode: "KEEP",
        name: i18n._(t`Stellar Punch`),
        description: i18n._(t`Punch to kill (and to win). You will receive 1 [Star] when you attack players using the dice`)
    },
    stellar_wallet: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`Stellar Wallet`),
        description: i18n._(t`Spend like a true star! Every time you buy a card (other than this one), earn 1 [Star]`)
    },
    watch_and_earn: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`Watch and Earn`),
        description: i18n._(t`Their death was sad. For them! Earn 3 [Star] every time another monster dies`)
    },
    six_is_the_count: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`Six is the Count`),
        description: i18n._(t`Six is not an odd number at all! Earn 1 [Star] for each 6 [Energy] you have at the end of your turn`)
    },
    the_underdog: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`The Underdog`),
        description: i18n._(t`The universe shows you some mercy. Earn 1 [Star] if you are the monster with the least [Star] at the end of a turn`)
    },
    luxurious_hotel: {
        cost: 4,
        use_mode: "KEEP",
        name: i18n._(t`Luxurious Hotel`),
        description: i18n._(t`Get hosted at the best hotel in town. Earn an extra 1 [Star] when starting your turn in the Town`)
    },
    poker: {
        cost: 2,
        use_mode: "KEEP",
        name: i18n._(t`POKER?`),
        description: i18n._(t`Not really poker... Almost! Roll [Roll-1][Roll-2][Roll-3][Roll-Heart][Roll-Damage][Roll-Energy] to earn 9 [Energy] (in addition to the obtained dice results)`)
    },
    three_one_four_two: {
        cost: 4,
        use_mode: "KEEP",
        name: i18n._(t`Three One Fo(u)r Two`),
        description: i18n._(t`Wait what? Read it again. If you roll [Roll-1][Roll-1][Roll-1], earn additional 2 [Star]`)
    },
    powerful_straight: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`Powerful Straight`),
        description: i18n._(t`Straight, all the way up. Roll [Roll-1][Roll-2][Roll-3] in order to earn 2 [Star]`)
    },
    helping_cube: {
        cost: 7,
        use_mode: "KEEP",
        name: i18n._(t`Helping Cube`),
        description: i18n._(t`It is a cube, but it is not just a cube: it is a new die! Gain an extra die`)
    },
    rolling_addiction: {
        cost: 5,
        use_mode: "KEEP",
        name: i18n._(t`Rolling Addiction`),
        description: i18n._(t`You are rolling, rolling, rolliiinggg... Gain one extra dice roll per turn while holding this card`)
    },
    the_businessman: {
        cost: 3,
        use_mode: "KEEP",
        name: i18n._(t`The Businessman`),
        description: i18n._(t`Become the very best businessman in town. All the cards cost 1 [Energy] less (their discounted price becomes marked green instead of white)`)
    }
}
